import {SaaSTargetRepository} from '../SaaSTargetRepository';

const TAG = 'UserPropHelper';

// サーバーは 10 の位で切り捨てた件数を返すため、1〜9 件は 0 になる。
// 画面は 0 件を「- - -」と表示するので、0 件と区別するために「50 件未満」に入る値として返す
const BELOW_TEN_COUNT = 1;
console.log(TAG);

export type EncodedUserProp = {
  [key: string]: any;
};

export type RangeOptionDto = {
  lower: number;
  upper: number;
};

export type UserOptionDto = {
  gender?: string;
  ageRange?: RangeOptionDto;
  married?: boolean;
  residence?: string[];
  movingMethod?: string[];
  childrenTogether?: number;
  incomeRange?: RangeOptionDto;
  householdIncomeRange?: RangeOptionDto;
  familyTogether?: number;
  address?: number[];
  job?: number[];
  interest?: number[];
  childAge?: RangeOptionDto;
  cityCode?: string[];
  prefCode?: string[];
};

export class UserPropHelper {
  static async getUserCount(
    option: UserOptionDto,
  ): Promise<number | undefined> {
    console.log(TAG, option);
    const result = await SaaSTargetRepository.fetchUserCount(option);
    if (result.belowMin && result.count === 0) {
      return BELOW_TEN_COUNT;
    }
    return result.count;
  }
}
